(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-banners"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-banners"] && !Shopify.designMode) return;
  try {
    
  /* Ensure banner videos autoplay — handles mobile browser restrictions */
  (function () {
    var section = document.querySelector('.homepage-banners-wrapper');
    if (!section) return;
    var videos = section.querySelectorAll('video');
    if (!videos.length) return;
    function tryPlay(video) {
      if (video.paused) {
        video.play().catch(function () {
          /* Browser blocked autoplay — retry on first user interaction */
          var handler = function () {
            video.play().catch(function () {});
            document.removeEventListener('touchstart', handler);
            document.removeEventListener('click', handler);
          };
          document.addEventListener('touchstart', handler, { once: true, passive: true });
          document.addEventListener('click', handler, { once: true });
        });
      }
    }
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            tryPlay(entry.target);
          }
        });
      }, { threshold: 0.25 });
      videos.forEach(function (video) { observer.observe(video); });
    } else {
      videos.forEach(tryPlay);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
